import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/messages/$app/$tab")({
  staticData: {
    title: "edge.navigation.messages",
  },
});
